module.exports = __webpack_public_path__ + "static/media/driverProfile.f328b2a9.svg";